export const suffixKeys = {
  sheet_time: 'seconds',
  success_accuracy: '%',
  target_accuracy: '%',
  complete_in: 'days',
};

export const keyNames = {
  is_active: 'Is Active',
  success_accuracy: 'Success Accuracy',
  sheet_time: 'Sheet Time',
  target_accuracy: 'Target Accuracy',
  total_questions: 'Total Questions',
  complete_in: 'Complete In(days)',
  points_available: 'Points Available',
  learnosity_reference: 'Learnosity Reference',
};

export const tableKeys = [
  'id', 'code', 'name', 'description', 'learnosity_reference', 'sheet_time',
  'success_accuracy', 'target_accuracy', 'total_questions',
  'complete_in', 'points_available', 'is_active',
];
